import { render, staticRenderFns } from "./observed_10.vue?vue&type=template&id=6e28c9d8&scoped=true&"
var script = {}
import style0 from "./observed_10.vue?vue&type=style&index=0&id=6e28c9d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e28c9d8",
  null
  
)

export default component.exports